import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getActiveBreakpointName, getShowHiddenElements } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getElements } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { isHiddenForBreakpoint } from 'EmailEditorUI/utils/breakpointUtils';
function useColumnHeight({
  moduleIds
}) {
  const activeBreakpointName = useSelector(getActiveBreakpointName);
  const elements = useSelector(getElements);
  const showHiddenElements = useSelector(getShowHiddenElements);
  return useMemo(() => {
    if (showHiddenElements) {
      return moduleIds.size;
    }
    const hiddenIds = elements.filter(el => {
      return isHiddenForBreakpoint(activeBreakpointName, el === null || el === void 0 ? void 0 : el.get('styles')) && moduleIds.includes(el.get('id'));
    });
    return moduleIds.size - hiddenIds.size;
  }, [activeBreakpointName, elements, moduleIds, showHiddenElements]);
}
export default useColumnHeight;